import React, {useEffect, useState} from 'react';
import {useParams} from 'react-router-dom';
import axios from 'axios';
import Swal from 'sweetalert2';
import {baseUrl} from '../Univ.js'
const CancelBill = (props) => {
    const {pat_id} = useParams();
    const [rows, setRows] = useState([]);
    const [patientData, setPatientData] = useState([]);
    const [combinedData, setCombinedData] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    useEffect(() => {
        async function fetchData() {
            try {
                const patResponse = await axios.get(`${baseUrl}pat-id/${pat_id}/`);
                const patData = patResponse.data;
                if (patData.length > 0) {
                    const patId = patData[0].id;
                    const emrResponse = await axios.get(`${baseUrl}emr-view/?pat_id=${patId}&status=1`);
                    const combinedData = emrResponse.data;
                    setPatientData(patData);
                    setCombinedData(combinedData);
                }
            } catch (error) {
                console.log(error);
            }
        }
        fetchData();
    }, [pat_id]);
    const handleOpCancel = (id) => {
        confirmAndDelete(`${baseUrl}delete-op-payment/${id}/`);
    };
    const handleLabCancel = (id) => {
        confirmAndDelete(`${baseUrl}delete-lab-payment/${id}/`);
    };
    const handleInvCancel = (id) => {
        confirmAndDelete(`${baseUrl}delete-inv-payment/${id}/`);
    };
    const handleMinCancel = (id) => {
        confirmAndDelete(`${baseUrl}delete-min-payment/${id}/`);
    };
    const confirmAndDelete = (url) => {
        Swal.fire({
            title: 'Are you sure?',
            text: 'This will cancel the bill!',
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            confirmButtonText: 'Yes, cancel it!'
        }).then((result) => {
            if (result.isConfirmed) {
                axios.delete(url)
                    .then(() => {
                        Swal.fire('Cancelled!', 'Bill cancelled.', 'success');
                        window.location.reload();
                    })
                    .catch(err => {
                        console.log(err);
                        Swal.fire('Error!', 'Cancel failed.', 'error');
                    });
            }
        });
    };
    return (
        <section className="container mt-4">
            <div className="row table-responsive">
                <div className='col-md-12 col-12 mb-2'>
                    <table className="erp-table-modern">
                        <thead>
                        <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                            <th>Patient ID</th>
                            <th>Patient Name</th>
                            <th>Gender</th>
                            <th>D.O.B/Age</th>
                            <th>Mobile</th>
                            <th>Regd. On</th>
                        </tr>
                        </thead>

                        <tbody>
                        {patientData.map((patientData, index) => (
                            <tr key={index}>
                                <td>{patientData.pat_id}</td>
                                <td>{patientData.patient}</td>
                                <td>{patientData.gender}</td>
                                <td>{patientData.age}</td>
                                <td>{patientData.mobile}</td>
                                <td>{patientData.add_date}</td>
                            </tr>
                        ))}
                        </tbody>
                    </table>
                    {!isLoading && combinedData.length > 0 ? (
                        <div className="table-responsive">
                            <h3 className="text-center" style={{color: 'white', backgroundColor: '#0dcaf0'}}>
                                <i className="fa-solid fa-indian-rupee-sign" aria-hidden="true"
                                   style={{color: 'red'}}></i>
                                OP Cancel Request
                            </h3>
                            <table className="erp-table-modern">

                                <thead>
                                <tr style={{backgroundColor: '#1bc5ce', color: 'white'}}>
                                    <th>Date</th>
                                    <th>Appointment ID</th>
                                    <th>Patient ID</th>
                                    <th>Patient Name</th>

                                    <th>Total Amount</th>

                                    <th>Action</th>
                                </tr>
                                </thead>
                                <tbody>
                                {combinedData.map(payment => (
                                    <tr key={payment.id}>

                                        <>
                                            <td>{payment.add_date_date}<br/>{payment.add_time}</td>
                                            <td>{payment.appt_id}</td>
                                            <td>{payment.pat__pat_id}</td>
                                            <td>{payment.pat__patient}</td>
                                            <td>{payment.fee || payment.lab_tot || payment.inv_tot || payment.min_tot}</td>
                                            <td>
                                                {payment.fee ? (
                                                    <button
                                                        className="btn btn-danger"
                                                        onClick={() => handleOpCancel(payment.id)}
                                                    >
                                                        Cancel
                                                    </button>
                                                ) : payment.lab_tot ? (
                                                    <button
                                                        className="btn btn-danger"
                                                        onClick={() => handleLabCancel(payment.id)}
                                                    >
                                                        Cancel
                                                    </button>
                                                ) : payment.inv_tot ? (
                                                    <button
                                                        className="btn btn-danger"
                                                        onClick={() => handleInvCancel(payment.id)}
                                                    >
                                                        Cancel
                                                    </button>
                                                ) : payment.min_tot ? (
                                                    <button
                                                        className="btn btn-danger"
                                                        onClick={() => handleMinCancel(payment.id)}
                                                    >
                                                        Cancel
                                                    </button>
                                                ) : null}
                                            </td>
                                        </>

                                    </tr>
                                ))}
                                </tbody>
                            </table>
                        </div>
                    ) : (
                        <></>
                    )}

                </div>
            </div>
        </section>
    );
};
export default CancelBill;
